import laptopmain from "../../Assets/laptopmain.png";
import deadline_reminders from "../../Assets/deadline_reminders.webp";
import bbps from "../../Assets/bbps.webp";
import retailer from "../../Assets/retailer.webp";
import information_retrieval from "../../Assets/information_retrieval.webp";
import real_time_reporting from "../../Assets/real_time_reporting.webp";
import {
  Store,
  TrendingUp,
  Landmark,
  Receipt,
  Smartphone,
  ShieldCheck,
  ArrowRight,
} from "lucide-react";

const services = [
  {
    title: "Bharat Bill Payment System (BBPS) ",
    description:
      "Bharat Bill Payment System is an integrated bill Payment system in India offering interoperable.",
    image: bbps,
    icon: <Landmark className="w-6 h-6 text-pink-500" />,
    tag: "Banking",
  },
  {
    title: "Information retrieval",
    description:
      "Always available Email, phone and Chat based support to help you in your every step.",
    image: information_retrieval,
    icon: <Receipt className="w-6 h-6 text-blue-500" />,
    tag: "Payments",
  },
  {
    title: "Real Time Reporting",
    description:
      "Option to toggle between better performance, better pricing and faster/greater value.",
    image: real_time_reporting,
    icon: <Smartphone className="w-6 h-6 text-orange-500" />,
    tag: "Recharge",
  },
  {
    title: "Deadline reminders",
    description:
      "Our teams to drive unprecedented profitability while focusing on operational excellence and cost.",
    image: deadline_reminders,
    icon: <Smartphone className="w-6 h-6 text-orange-500" />,
    tag: "Recharge",
  },
];

export default function Retailer() {
  return (
    <div className="bg-white">
      <section className="relative w-full bg-[#000856] pt-20 pb-20 md:pt-20 md:pb-40 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div
            className="absolute inset-0 opacity-[0.05] [mask-image:radial-gradient(ellipse_at_center,white,transparent)]"
            style={{
              backgroundImage: "radial-gradient(#fff 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />

          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-500/20 blur-[130px] rounded-full -mr-40 -mt-20 animate-pulse" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-pink-500/10 blur-[110px] rounded-full -ml-20 -mb-20" />
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-20">
            <div className="w-full lg:w-1/2 space-y-10">
              <div className="inline-flex items-center space-x-3 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-xl">
                <Store className="text-pink-400 w-4 h-4" />
                <span className="text-blue-100 text-xs font-bold uppercase tracking-[0.2em]">
                  Retailer Growth Program
                </span>
              </div>

              <div className="space-y-6">
                <h1 className="font-spacegrotesk text-white text-5xl md:text-7xl font-bold leading-[1.05] tracking-tight">
                  Empower Your <br />
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-orange-400 to-pink-500">
                    Business Hub
                  </span>
                </h1>
                <p className="text-blue-100/70 text-lg md:text-xl leading-relaxed max-w-xl">
                  Transform your local shop into a full-service digital bank.
                  Earn higher margins, attract more footfall, and lead the
                  digital revolution.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  {
                    title: "Instant Payouts",
                    icon: <TrendingUp className="w-5 h-5" />,
                  },
                  {
                    title: "Secure Platform",
                    icon: <ShieldCheck className="w-5 h-5" />,
                  },
                ].map((benefit, i) => (
                  <div
                    key={i}
                    className="flex items-center space-x-3 p-4 rounded-2xl bg-white/5 border border-white/10"
                  >
                    <div className="text-pink-400">{benefit.icon}</div>
                    <span className="text-white font-semibold">
                      {benefit.title}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-1/2 relative">
              <div className="relative z-10 animate-float px-4">
                <div className="relative rounded-[2.5rem] overflow-hidden border-[8px] border-white/10 shadow-2xl">
                  <img
                    src={retailer}
                    alt="Bumppy Retailer"
                    className="w-full h-auto object-cover"
                  />

                  <div className="absolute bottom-0 left-0 right-0 h-1/3" />
                </div>

                <div className="absolute -top-6 -right-6 md:-right-10 bg-white p-5 rounded-[2rem] shadow-2xl z-30 animate-bounce-slow">
                  <div className="flex items-center space-x-4">
                    <div className="h-12 w-12 rounded-full bg-green-500/10 flex items-center justify-center">
                      <TrendingUp className="text-green-600 w-6 h-6" />
                    </div>
                    <div>
                      <p className="text-slate-400 text-[10px] font-bold uppercase tracking-wider">
                        Success Rate
                      </p>
                      <p className="text-slate-900 text-xl font-black">99.9%</p>
                    </div>
                  </div>
                </div>

                <div className="absolute -bottom-10 -left-6 md:-left-12 bg-gradient-to-br from-pink-500 to-orange-400 p-6 rounded-[2rem] shadow-2xl z-30">
                  <div className="text-white">
                    <p className="text-[10px] font-bold uppercase opacity-80">
                      Retailer Earnings
                    </p>
                    <p className="text-2xl font-black">
                      ₹ 50k+ <span className="text-sm font-normal">/mo</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style
          dangerouslySetInnerHTML={{
            __html: `
            @keyframes float {
              0%, 100% { transform: translateY(0px) skewY(0deg); }
              50% { transform: translateY(-25px) skewY(1deg); }
            }
            @keyframes bounce-slow {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-15px); }
            }
            .animate-float { animation: float 8s ease-in-out infinite; }
            .animate-bounce-slow { animation: bounce-slow 5s ease-in-out infinite; }
          `,
          }}
        />
      </section>

      <section className="py-20 bg-slate-50/50">
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <header className="text-center max-w-2xl mx-auto mb-16 space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
              Capabilities
            </span>
            <h2 className="font-spacegrotesk text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-none">
              Our Services
            </h2>
            <p className="text-slate-500 text-base sm:text-lg">
              We provide end-to-end engineered solutions customized to
              accelerate growth and maximize operational efficiency.
            </p>
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
            {services.map((service, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-2xl overflow-hidden border border-slate-200/60 shadow-sm hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-500 hover:-translate-y-2 flex flex-col h-full"
              >
                <div className="relative h-60 w-full overflow-hidden bg-slate-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    loading="lazy"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/40 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" />

                  <div className="absolute top-4 left-4 px-3.5 py-1.5 bg-white/80 backdrop-blur-md border border-white/40 rounded-full text-[10px] font-bold uppercase tracking-wider text-slate-800 shadow-sm">
                    {service.tag}
                  </div>
                </div>

                <div className="p-6 sm:p-8 flex flex-col flex-grow justify-between space-y-4">
                  <div className="space-y-3">
                    <h3 className="text-xl sm:text-2xl font-bold text-slate-900 group-hover:text-blue-600 transition-colors duration-300">
                      {service.title}
                    </h3>

                    <p className="text-slate-500 text-sm sm:text-base leading-relaxed line-clamp-3">
                      {service.description}
                    </p>
                  </div>

                  <div className="pt-2 flex items-center text-sm font-semibold text-blue-600 group-hover:text-blue-700 transition-colors duration-300">
                    <span>Learn more</span>
                    <svg
                      className="w-4 h-4 ml-1.5 transform transition-transform duration-300 group-hover:translate-x-1.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2.5}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="bg-slate-300 py-16 md:py-24 font-inter px-6 md:0 ">
        <section className="py-24 bg-slate-50 overflow-hidden">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col lg:flex-row items-center gap-16 md:gap-24">
              <div className="w-full lg:w-1/2 space-y-8">
                <div className="space-y-4">
                  <h2 className="font-spacegrotesk text-slate-900 text-4xl md:text-5xl lg:text-5xl font-bold leading-tight">
                    Easy Payment to get a <br />
                    <span className="text-blue-600">better reporting</span> at
                    home
                  </h2>

                  <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                    Enabling the fully digital banking ecosystem, with the
                    instant account opening, serving paperless experience with
                    cash deposit and withdrawal facility.
                  </p>

                  <p className="text-slate-500 text-base leading-relaxed border-l-4 border-slate-200 pl-6 py-1">
                    As Bumppy Payments we’re working with banks across the
                    continuum of innovation while developing leading digital
                    capabilities for the leading banks with solutions that are
                    both executable & differentiating.
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4 ">
                  <div className="flex items-center space-x-4 group cursor-default">
                    <div className="h-12 w-12 rounded-2xl bg-white shadow-sm flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                      <Smartphone className="w-6 h-6" />
                    </div>
                    <span className="font-bold text-slate-800">
                      Instant Activation
                    </span>
                  </div>
                  <div className="flex items-center space-x-4 group cursor-default">
                    <div className="h-12 w-12 rounded-2xl bg-white shadow-sm flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                      <ShieldCheck className="w-6 h-6" />
                    </div>
                    <span className="font-bold text-slate-800">
                      100% Secure
                    </span>
                  </div>
                </div>

                <a href="https://dashboard.bumppy.com/register">
                  <button className="flex items-center space-x-2 mt-10 rounded-xl text-white py-2 px-4 bg-indigo-600 font-bold text-lg hover:space-x-4 transition-all duration-300">
                    <span>Join Now</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </a>
              </div>

              <div className="w-full lg:w-1/2 relative">
                <div className="relative z-10 animate-float">
                  <div className="absolute inset-0 bg-blue-400/20 blur-[100px] rounded-full -z-10" />

                  <div className="relative  overflow-hidden  ">
                    <img
                      src={laptopmain}
                      alt="Digital Banking Reporting"
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <style
            dangerouslySetInnerHTML={{
              __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          .animate-float { animation: float 6s ease-in-out infinite; }
        `,
            }}
          />
        </section>
      </section>
    </div>
  );
}
